import React from 'react';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { offerCards } from '../data/content';
export function Offer() {
  return <section id="oferta" className="w-full scroll-mt-16 bg-cream py-16 sm:py-20" data-id="element-116" data-mp="1mnivdk6txrhm">
      <div className="mx-auto max-w-6xl px-5 sm:px-6" data-id="element-117" data-mp="1mplhht4v30h2">
        <Reveal className="text-center" data-id="element-118" data-mp="1hph080w4q1ps">
          <h2 className="text-[26px] font-bold tracking-tight text-forest sm:text-[32px]" data-id="element-119" data-mp="1hqio55y8uiox">
            Todo Lo Que Recibes Hoy
          </h2>
          <p className="mt-2 text-base text-warmgray" data-id="element-120" data-mp="p0a6rgbj82be">Un sistema completo — no solo un ebook.</p>
        </Reveal>

        <ul className="snap-x-mandatory mt-10 -mx-5 flex gap-4 overflow-x-auto px-5 pb-4 md:mx-0 md:grid md:grid-cols-2 md:overflow-visible md:px-0 md:pb-0 md:gap-6" data-id="element-121" data-mp="13y2gfruedwho">
          {offerCards.map((card, i) => <Reveal as="li" key={card.title} delay={i * 0.07} className="w-[85vw] max-w-sm shrink-0 snap-center md:w-auto md:max-w-none" data-id="element-122" data-mp="2fb4xsp4bmq2w" data-mpi={i}>
              <article className={`flex h-full flex-col rounded-2xl bg-white p-6 ${card.featured ? 'shadow-lg' : 'shadow-sm'}`} style={{
            borderLeft: `${card.borderWidth} solid ${card.borderColor}`
          }} data-id="element-123" data-mp="2af7hujwyzlqn">
                <span className={`inline-flex w-fit rounded-full px-3 py-1 text-[11px] font-bold tracking-wide ${card.badgeClass}`} data-id="element-124" data-mp="zies7r8xkf54">
                  {card.badge}
                </span>

                <div className="mt-5 flex justify-center" data-id="element-125" data-mp="13hnmcx7vuf17">
                  <img src={card.image} alt={card.imageAlt} className="max-h-40 w-auto rounded-lg object-contain shadow-md" loading="lazy" data-id="element-126" data-mp="6v0qzgy78xf7" />
                </div>

                <h3 className={`mt-5 font-bold leading-snug tracking-tight ${card.titleClass}`} data-id="element-127" data-mp="ftvzizopujlo">
                  {card.title}
                </h3>

                {card.subtitle && <p className="mt-1 text-sm font-medium text-warmgray" data-id="element-128" data-mp="kn8juxmd448m">{card.subtitle}</p>}

                <p className="mt-2 text-sm leading-relaxed text-charcoal/80" data-id="element-129" data-mp="3k6jdohz22o1j">{card.description}</p>

                <p className="mt-auto pt-5 text-sm font-semibold text-forest" data-id="element-130" data-mp="3o84m9r4k4g5x">
                  <span className="text-warmgray line-through" data-id="element-131" data-mp="ve60y811zls8">{card.value}</span>
                  <span className="mx-2 text-warmgray/50" data-id="element-132" data-mp="qfmgyd60sk2i">→</span>
                  Incluido hoy
                </p>
              </article>
            </Reveal>)}
        </ul>

        {/* Total value */}
        <Reveal delay={0.06} data-id="element-133" data-mp="107ienn472867">
          <div className="mx-auto mt-10 max-w-lg rounded-2xl bg-gold px-6 py-7 text-center" data-id="element-134" data-mp="1078uwh9qsx8y">
            <p className="text-[18px] font-semibold text-forest line-through" data-id="element-135" data-mp="ch4tmgk119l4">Valor total: $238 USD</p>
            <p className="mt-1 text-[32px] font-bold tracking-tight text-forest sm:text-[36px]" data-id="element-136" data-mp="7jmmmvpkl4fr">
              Tu precio hoy: $9.99 USD
            </p>
            <p className="mt-1 text-sm font-semibold text-forest/80" data-id="element-137" data-mp="hfpw6mmr45cq">
              Ahorro del 96% — Precio de lanzamiento
            </p>
          </div>
        </Reveal>

        {/* CTA #1 */}
        <Reveal delay={0.1} className="mt-8 flex flex-col items-center" data-id="element-138" data-mp="1svnzsaz5tz6k">
          <a href="https://pay.hotmart.com/I107312371O?checkoutMode=10&bid=1787773315893" target="_blank" rel="noopener noreferrer" className="flex min-h-14 w-full max-w-lg items-center justify-center rounded-2xl bg-coral px-6 py-4 text-center text-base font-bold leading-tight text-white shadow-xl transition-transform duration-150 ease-out hover:scale-[1.02] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-forest sm:text-lg" data-id="element-139" data-mp="20enhmc6z3int">
            QUIERO TODO ESTO POR $9.99 USD — ACCESO INMEDIATO →
          </a>

          <p className="mt-3 flex items-center gap-1.5 text-xs text-warmgray" data-id="element-140" data-mp="2o3oucbmu9fyw">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-141" data-mp="29eakz3j9iyji" />
            Pago único · Descarga instantánea · Garantía 07 días
          </p>
          <p className="mt-1.5 flex items-center gap-1.5 text-xs font-semibold text-forest" data-id="element-142" data-mp="2ecc5lswc75x3">
            <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-143" data-mp="321wm8550pr37" />
            Sin riesgo
          </p>
        </Reveal>
      </div>
    </section>;
}